import { z } from "zod"
import { getPartnerConfig } from "@/features/partners"
import { Partner } from "@/features/partners/constants/partner"

const baseQueryParamsSchema = z.object({
    pmaxToken: z.string().optional(),
    affiliation: z.string().optional(),
    affiliate: z.string().optional(),
    affiliateQueryParams: z.object().catchall(z.unknown()).optional(),
    codeParrainage: z.string().optional(),
    codePromo: z.string().optional(),
    electricityMeterPointId: z.string().optional(),
    givenName: z.string().optional(),
    familyName: z.string().optional(),
    errorCode: z.string().optional(),
})

type BaseQueryParams = z.infer<typeof baseQueryParamsSchema>
type QueryParamsWithPartner = BaseQueryParams & { partnerSlug: Partner }

export const createOnboardingQueryParamsSchema = (options?: { isPartnerJourney?: boolean }) => {
    const schema = options?.isPartnerJourney
        ? baseQueryParamsSchema.extend({
              partnerSlug: z.nativeEnum(Partner),
          })
        : baseQueryParamsSchema

    return schema.transform((data: BaseQueryParams | QueryParamsWithPartner) => {
        const hasPartnerSlug = "partnerSlug" in data

        const baseSchema = {
            partnerSlug: null,
            pmaxAnalysisToken: data.pmaxToken ?? null,
            affiliateCode: data.affiliation ?? data.affiliate,
            affiliateQueryParams: data.affiliateQueryParams ?? null,
            rewardCode: data.codeParrainage ?? data.codePromo ?? null,
            electricityMeterPointId: data.electricityMeterPointId ?? null,
            givenName: data.givenName ?? null,
            familyName: data.familyName ?? null,
            errorCode: data.errorCode ?? null,
        }

        if (hasPartnerSlug) {
            const { affiliateCode: defaultAffiliateCode } = getPartnerConfig(data.partnerSlug)

            return {
                ...baseSchema,
                partnerSlug: data.partnerSlug,
                affiliateCode: data.affiliation ?? data.affiliate ?? defaultAffiliateCode,
            }
        }

        return baseSchema
    })
}

export type OnboardingQueryParams = z.infer<ReturnType<typeof createOnboardingQueryParamsSchema>>
